import { render, staticRenderFns } from "./DraftItem.vue?vue&type=template&id=3ad48f0e&scoped=true&"
import script from "./DraftItem.vue?vue&type=script&lang=js&"
export * from "./DraftItem.vue?vue&type=script&lang=js&"
import style0 from "./DraftItem.vue?vue&type=style&index=0&id=3ad48f0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad48f0e",
  null
  
)

export default component.exports